import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShareMailService {
  constructor(
    private http: HttpClient,
  ) {}

  shareByMail(id?: any, data?: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/property/${id}/share`,
      data
    );
  }
}
